import { CURRENT, LOCATIONS } from "./cities";

/**
 * Network proof numbers — one source for every surface that quotes them.
 *
 * These used to be two independent literals: `TRUST` in TrustBar.tsx and a
 * second array in PriceBlock.tsx, both spelling out "68 000+" by hand. The
 * article conversion blocks would have added a third and a fourth copy. A
 * number that lives in four places drifts in three of them, and nobody notices
 * until a patient sees two different totals on two pages of the same site.
 *
 * 🔴 The city count is DERIVED, never typed. Adding a location to LOCATIONS
 * updates the trust bar, the in-article block and the closing block at once —
 * the previous hardcoded "8" was the exact kind of number that survives a
 * ninth city opening.
 */
export const EXAMS_DONE = "68 000+";
export const REMOVALS_DONE = "59 000+";
export const DOCTORS_COUNT = "100+";
export const BOOKING_AVAILABILITY = "24/7";

export const CITIES_COUNT = LOCATIONS.filter((location) => location.type === CURRENT).length;
export const CITIES_COUNT_DISPLAY = String(CITIES_COUNT);
